/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { killswitchesLift } from "../funcs/killswitchesLift.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { KillswitchLiftResult } from "../models/components/killswitchliftresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { KillswitchConflict } from "../models/errors/killswitchconflict.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  KillswitchesLiftRequest,
  KillswitchesLiftSecurity,
} from "../models/operations/killswitcheslift.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type LiftKillswitchMutationVariables = {
  security: KillswitchesLiftSecurity;
  request: KillswitchesLiftRequest;
  options?: RequestOptions;
};

export type LiftKillswitchMutationData = KillswitchLiftResult;

export type LiftKillswitchMutationError =
  | KillswitchConflict
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * lift killswitches
 */
export function useLiftKillswitchMutation(
  options?: MutationHookOptions<
    LiftKillswitchMutationData,
    LiftKillswitchMutationError,
    LiftKillswitchMutationVariables
  >,
): UseMutationResult<
  LiftKillswitchMutationData,
  LiftKillswitchMutationError,
  LiftKillswitchMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildLiftKillswitchMutation(client, options),
    ...options,
  });
}

export function mutationKeyLiftKillswitch(): MutationKey {
  return ["@gram/client", "killswitches", "lift"];
}

export function buildLiftKillswitchMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: LiftKillswitchMutationVariables,
  ) => Promise<LiftKillswitchMutationData>;
} {
  return {
    mutationKey: mutationKeyLiftKillswitch(),
    mutationFn: function liftKillswitchMutationFn({
      security,
      request,
      options,
    }): Promise<LiftKillswitchMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(killswitchesLift(
        client$,
        security,
        request,
        mergedOptions,
      ));
    },
  };
}
